<template>
  <div :class="{ 'issue-field': true, 'issue-field--error': error }">
    <div class="issue-field__wrapper">
      <div class="issue-field__header">
        <div class="issue-field__title">{{$t('issues.location')}}</div>
      </div>

      <div class="issue-field__body issue-field__body--inline typo-field-text">
        <div class="issue__input typo-ignore" v-if="modelValue">{{ locationDescription }}</div>
        <div class="issue__input issue__input--placeholder typo-ignore" v-else>{{ placeholder }}</div>
        <button type="button" class="issue-field__action" @click="beginEdit" v-if="canEdit">
          <span>{{ $t('general.edit') }}</span>
          <UseSvg name="pencil_24" />
        </button>
      </div>
    </div>

    <IssueLocationModal
      v-if="modalOpen"
      :location="modelValue"
      @cancel="modalOpen = false"
      @submit="saveLocation"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import I18n from 'i18n-js';

import UseSvg from '@/components/generic/use_svg.vue';
import IssueLocationModal from '@/components/shafts/issue_location_modal.vue';

const props = defineProps({
  modelValue: { type: Object, default: null },
  placeholder: { type: String, default: '' },
  error: { type: Boolean, default: false },
  canEdit: Boolean,
});
const emit = defineEmits(['update:modelValue']);

const open = ref(false);
const modalOpen = ref(false);

const locationDescription = computed(() => {
  if (!props.modelValue) return;

  switch (props.modelValue.type) {
    case 'shaft':
      return [
        I18n.t(`shafts.element_types.shaft.${props.modelValue.elementType}`),
        props.modelValue.element.group_name,
        props.modelValue.element.name,
        `${I18n.t('shafts.issues.set')} ${props.modelValue.set}`,
      ].join(', ');
    case 'station':
      return [
        props.modelValue.station.name,
        props.modelValue.stationMember.name,
      ].join(', ');
    default:
      return [];
  }
});

function beginEdit() {
  open.value = false;
  modalOpen.value = true;
}

async function saveLocation(newLocation) {
  modalOpen.value = false;
  emit('update:modelValue', newLocation);
}
</script>
